var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-progress',{attrs:{"type":_vm.progressColor(_vm.number),"value":_vm.number,"show-value":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }